
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3b99"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3b99"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4SSe9", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $38e644f71e40bb30$export$6503ec6e8aabbaf; }, function (v) { return $38e644f71e40bb30$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $38e644f71e40bb30$export$f7ad0328861e2f03; }, function (v) { return $38e644f71e40bb30$export$f7ad0328861e2f03 = v; });
var $38e644f71e40bb30$export$6503ec6e8aabbaf;
var $38e644f71e40bb30$export$f7ad0328861e2f03;
"use strict";
var $38e644f71e40bb30$var$mapping = new Map();
function $38e644f71e40bb30$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$38e644f71e40bb30$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $38e644f71e40bb30$var$resolve(id) {
    var resolved = $38e644f71e40bb30$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$38e644f71e40bb30$export$6503ec6e8aabbaf = $38e644f71e40bb30$var$register;
$38e644f71e40bb30$export$f7ad0328861e2f03 = $38e644f71e40bb30$var$resolve;

});

parcelRegister("8kXei", function(module, exports) {

$parcel$export(module.exports, "getBoardBackground", function () { return $611e22bdabd0ce90$export$c4c46bad752d591; });
$parcel$export(module.exports, "getCardStatusAndData", function () { return $611e22bdabd0ce90$export$f91343abda391f69; });
$parcel$export(module.exports, "batchGetCardStatusAndData", function () { return $611e22bdabd0ce90$export$4209193825acda6; });
$parcel$export(module.exports, "postCardToTrello", function () { return $611e22bdabd0ce90$export$66bee85da68380c6; });
$parcel$export(module.exports, "updateTrelloCard", function () { return $611e22bdabd0ce90$export$93cc293aded8a20d; });
$parcel$export(module.exports, "getOrgData", function () { return $611e22bdabd0ce90$export$b33cb91588a77588; });
const $611e22bdabd0ce90$var$apiKey = "37755754d9f6ca0143afd7c4d5f116dd";
async function $611e22bdabd0ce90$export$c4c46bad752d591(t, boardId) {
    const token = await t.get("member", "private", "token");
    if (!token || token.includes("rejected")) return null;
    else return fetch(`https://api.trello.com/1/boards/${boardId}?fields=prefs&key=${$611e22bdabd0ce90$var$apiKey}&token=${token}`).then((response)=>response.json()).then((data)=>{
        if (data.prefs) return {
            url: data.prefs.backgroundImage,
            color: data.prefs.backgroundColor,
            topColor: data.prefs.backgroundTopColor,
            brightness: data.prefs.backgroundBrightness
        };
        return null;
    }).catch((error)=>{
        console.error("Failed to fetch Trello board background:", error);
        return null;
    });
}
async function $611e22bdabd0ce90$export$f91343abda391f69(t, cardId) {
    const token = await t.get("member", "private", "token");
    if (!token || token.includes("rejected")) return null;
    else return fetch(`https://api.trello.com/1/cards/${cardId}?checklists=all&members=true&key=${$611e22bdabd0ce90$var$apiKey}&token=${token}`).then(async (response)=>{
        const status = response.status; // Capture the status
        // Check if the response is OK (status in range 200-299)
        if (response.ok) {
            const data = await response.json(); // Parse the JSON data
            return {
                status: status,
                data: data
            }; // Return both status and data
        }
        // For other error statuses (not handled above), return status and no data
        return {
            status: status,
            data: null
        };
    }).catch((error)=>{
        console.error("Failed to fetch card status:", error);
        return {
            status: "error",
            data: null
        }; // Return an error status and null data for network issues
    });
}
async function $611e22bdabd0ce90$export$4209193825acda6(t, cardIds) {
    const token = await t.get("member", "private", "token");
    if (!token || token.includes("rejected")) return null;
    const batchUrls = cardIds.map((cardId)=>encodeURIComponent(`/cards/${cardId}?checklists=all&members=true`));
    // Split the cardIds into batches of 10 (as the batch API allows max 10 requests at a time)
    const batchedUrls = [];
    while(batchUrls.length)batchedUrls.push(batchUrls.splice(0, 10));
    const allResults = [];
    // Fetch data in batches using Trello's batch API
    await Promise.all(batchedUrls.map(async (batch)=>{
        const batchResponse = await fetch(`https://api.trello.com/1/batch?urls=${batch.join(",")}&key=${$611e22bdabd0ce90$var$apiKey}&token=${token}`);
        const batchData = await batchResponse.json();
        // Process each response
        batchData.forEach((response, index)=>{
            // Safely extract cardId from the batch URL
            const urlParts = decodeURIComponent(batch[index]).match(/\/cards\/([^?]+)/);
            const cardId = urlParts ? urlParts[1] : null;
            if (response[200]) allResults.push({
                id: cardId,
                status: 200,
                data: response[200]
            });
            else if (response.statusCode === 401 || response.statusCode === 404) allResults.push({
                id: cardId,
                status: response.statusCode,
                data: null
            });
            else allResults.push({
                id: cardId,
                status: "error",
                data: null
            });
        });
    }));
    return allResults; // Array of results for all cardIds
}
async function $611e22bdabd0ce90$export$66bee85da68380c6(t, cardName, selectedListId) {
    const token = await t.get("member", "private", "token");
    if (!token || token.includes("rejected")) return null;
    else {
        const url = `https://api.trello.com/1/cards?name=${encodeURIComponent(cardName)}&idList=${selectedListId}&key=${$611e22bdabd0ce90$var$apiKey}&token=${token}`;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json"
                }
            });
            if (!response.ok) throw new Error(`Network response was not ok: ${response.statusText}`);
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Error posting card to Trello:", error);
        }
    }
}
async function $611e22bdabd0ce90$export$93cc293aded8a20d({ t: t, cardId: cardId, queryParam: queryParam, updatedData: updatedData }) {
    const token = await t.get("member", "private", "token");
    if (!token || token.includes("rejected")) return null;
    const url = `https://api.trello.com/1/cards/${cardId}?${queryParam}=${updatedData}&key=${$611e22bdabd0ce90$var$apiKey}&token=${token}`;
    try {
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                Accept: "application/json"
            }
        });
        if (!response.ok) throw new Error(`Network response was not ok: ${response.statusText}`);
    } catch (error) {
        console.error("Error updating Trello card:", error);
    }
}
async function $611e22bdabd0ce90$export$b33cb91588a77588(t) {
    const organization = await t.organization("id");
    const organizationId = organization.id;
    const token = await t.get("member", "private", "token");
    if (!token || token.includes("rejected")) return null;
    let orgData = {
        boards: [],
        lists: [],
        cards: [],
        members: []
    };
    // Find boards that the member has access to for this organization
    const boardOptions = await $611e22bdabd0ce90$var$getBoards(token, organizationId);
    orgData.boards = boardOptions;
    // Fetch members for the organization
    const members = await $611e22bdabd0ce90$var$getOrganizationMembers(token, organizationId);
    if (members) orgData.members = members;
    // Prepare batch requests for lists and cards, ensuring proper URI encoding
    const batchUrls = [];
    boardOptions.forEach((board)=>{
        batchUrls.push(encodeURIComponent(`/boards/${board.id}/lists?filter=open`));
        batchUrls.push(encodeURIComponent(`/boards/${board.id}/cards?filter=visible&checklists=all&members=true`));
    });
    // Split into batches of 10 requests
    const batchedUrls = [];
    while(batchUrls.length)batchedUrls.push(batchUrls.splice(0, 10));
    // Use Promise.all to fetch data in batches
    await Promise.all(batchedUrls.map(async (batch)=>{
        const batchResponse = await fetch(`https://api.trello.com/1/batch?urls=${batch}&key=${$611e22bdabd0ce90$var$apiKey}&token=${token}`);
        const batchData = await batchResponse.json();
        // Process each response in the batchData array
        batchData.forEach((response, index)=>{
            const route = decodeURIComponent(batch[index]);
            if (response?.[200]) {
                if (route.includes("/lists")) // Process lists
                orgData.lists = orgData.lists.concat(response[200]);
                else if (route.includes("/cards")) // Process cards
                orgData.cards = orgData.cards.concat(response[200]);
            } else // Log the entire response for debugging
            console.error(`Error fetching data for ${route}:`, response);
        });
    }));
    return orgData;
}
// Function to fetch boards of the organization
async function $611e22bdabd0ce90$var$getBoards(token, organizationId) {
    const fields = [
        "id",
        "name",
        "idOrganization",
        "url"
    ];
    if (!token || token.includes("rejected")) return null;
    else return fetch(`https://api.trello.com/1/organizations/${organizationId}/boards?fields=${fields}&filter=open&key=${$611e22bdabd0ce90$var$apiKey}&token=${token}`).then((response)=>response.json()).then((data)=>{
        if (data) return data;
        return null;
    }).catch((error)=>{
        console.error("Failed to fetch org boards:", error);
        return null;
    });
}
// Function to fetch members of the organization
async function $611e22bdabd0ce90$var$getOrganizationMembers(token, organizationId) {
    if (!token || token.includes("rejected")) return null;
    try {
        const response = await fetch(`https://api.trello.com/1/organizations/${organizationId}/members?fields=id,fullName,username,avatarUrl&key=${$611e22bdabd0ce90$var$apiKey}&token=${token}`);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Failed to fetch organization members:", error);
        return null;
    }
}

});

var $247dd87c79417700$exports = {};

(parcelRequire("4SSe9")).register(new URL("", import.meta.url).toString(), JSON.parse('["dXJl9","index.fb0ac9ec.js","8CqFx","goals-icon.e462cf63.svg"]'));


var $8kXei = parcelRequire("8kXei");
// Convert HEX to RGB
function $c18cd860ef56e906$var$hexToRGB(hex) {
    return {
        r: parseInt(hex.slice(1, 3), 16),
        g: parseInt(hex.slice(3, 5), 16),
        b: parseInt(hex.slice(5, 7), 16)
    };
}
// Convert RGB to HSL
function $c18cd860ef56e906$var$rgbToHSL({ r: r, g: g, b: b }) {
    r /= 255;
    g /= 255;
    b /= 255;
    let max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        let d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: Math.round(h * 360),
        s: s * 100,
        l: l * 100
    };
}
// Adjust HSL for light background
function $c18cd860ef56e906$var$adjustHSLForLightBackground(hsl) {
    hsl.s = hsl.s * 0.9; // reduce saturation
    hsl.l = hsl.l + (100 - hsl.l) * 0.05; // slightly increase lightness
    return hsl;
}
// Adjust HSL for dark background
function $c18cd860ef56e906$var$adjustHSLForDarkBackground(hsl) {
    hsl.s = hsl.s * 1.1; // increase saturation
    hsl.l = hsl.l * 0.35; // decrease lightness
    return hsl;
}
// Convert HSL to RGB
function $c18cd860ef56e906$var$hslToRGB({ h: h, s: s, l: l }) {
    s /= 100;
    l /= 100;
    let c = (1 - Math.abs(2 * l - 1)) * s;
    let x = c * (1 - Math.abs(h / 60 % 2 - 1));
    let m = l - c / 2;
    let r = 0, g = 0, b = 0;
    if (h >= 0 && h < 60) {
        r = c;
        g = x;
        b = 0;
    } else if (h >= 60 && h < 120) {
        r = x;
        g = c;
        b = 0;
    } else if (h >= 120 && h < 180) {
        r = 0;
        g = c;
        b = x;
    } else if (h >= 180 && h < 240) {
        r = 0;
        g = x;
        b = c;
    } else if (h >= 240 && h < 300) {
        r = x;
        g = 0;
        b = c;
    } else if (h >= 300 && h < 360) {
        r = c;
        g = 0;
        b = x;
    }
    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);
    return {
        r: r,
        g: g,
        b: b
    };
}
// Convert RGB to HEX
function $c18cd860ef56e906$var$rgbToHex({ r: r, g: g, b: b }) {
    return `#${(16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}
function $c18cd860ef56e906$export$138a295197399d4d(hex, background) {
    let rgb = $c18cd860ef56e906$var$hexToRGB(hex);
    let hsl = $c18cd860ef56e906$var$rgbToHSL(rgb);
    if (background === "light") hsl = $c18cd860ef56e906$var$adjustHSLForLightBackground(hsl);
    else if (background === "dark") hsl = $c18cd860ef56e906$var$adjustHSLForDarkBackground(hsl);
    rgb = $c18cd860ef56e906$var$hslToRGB(hsl);
    return $c18cd860ef56e906$var$rgbToHex(rgb);
}


var $96b1dc6b9525294a$exports = {};
$96b1dc6b9525294a$exports = new URL("goals-icon.e462cf63.svg", import.meta.url).toString();


window.TrelloPowerUp.initialize({
    "board-buttons": function(t, opts) {
        return [
            {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($96b1dc6b9525294a$exports))),
                text: "Goals",
                condition: "edit",
                callback: async function(t) {
                    const token = await t.get("member", "private", "token");
                    if (!token || token.includes("rejected")) // return Auth modal if the user is not yet authorized
                    return t.modal({
                        title: "",
                        accentColor: "#1064E3",
                        url: "./authorize.html",
                        height: 593,
                        args: {
                            trigger: "show-authorization"
                        }
                    });
                    else return $b1a10cffc19030c2$var$openModal(t);
                }
            }
        ];
    },
    "card-back-section": function(t, opts) {
        return {
            title: "Goals",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($96b1dc6b9525294a$exports))),
            content: {
                type: "iframe",
                url: t.signUrl("./card-back.html")
            },
            action: {
                text: "View all",
                callback: async function(t) {
                    const token = await t.get("member", "private", "token");
                    if (!token || token.includes("rejected")) // return Auth modal if the user is not yet authorized
                    return t.modal({
                        title: "",
                        accentColor: "#1064E3",
                        url: "./authorize.html",
                        height: 593,
                        args: {
                            trigger: "show-authorization"
                        }
                    });
                    else return $b1a10cffc19030c2$var$openModal(t);
                }
            }
        };
    },
    "show-settings": function(t, opts) {
        return t.popup({
            title: "Goals Settings",
            url: "./settings.html"
        });
    },
    "on-enable": async function(t, opts) {
        const existingGoals = await t.get("organization", "shared", "goals");
        if (existingGoals === undefined) await t.set("organization", "shared", "goals", {});
        return t.modal({
            title: "",
            accentColor: "#1064E3",
            url: "./authorize.html",
            height: 593,
            args: {
                trigger: "onEnable"
            }
        });
    },
    "authorization-status": async function(t, options) {
        const token = await t.get("member", "private", "token");
        if (!token || token.includes("rejected")) return {
            authorized: false
        };
        else return {
            authorized: true
        };
    },
    "show-authorization": function(t, opts) {
        return t.modal({
            title: "",
            accentColor: "#1064E3",
            url: "./authorize.html",
            height: 593,
            args: {
                trigger: "show-authorization"
            }
        });
    }
}, {
    appKey: "37755754d9f6ca0143afd7c4d5f116dd",
    appName: "Goals",
    appAuthor: "Native Power-Ups"
});
const $b1a10cffc19030c2$var$openModal = async (t)=>{
    const context = t.getContext();
    const theme = context.initialTheme;
    const boardId = context.board;
    const background = await (0, $8kXei.getBoardBackground)(t, boardId);
    const adjustedTopColor = (0, $c18cd860ef56e906$export$138a295197399d4d)(background.topColor, background.brightness);
    return t.modal({
        title: "Goals",
        url: "./modal.html",
        accentColor: theme === "dark" ? "#161A1D" : background ? adjustedTopColor : "",
        fullscreen: true
    });
};


//# sourceMappingURL=index.fb0ac9ec.js.map
